import { IS_LOGGED_IN_FALSE, IS_LOGGED_IN_TRUE } from 'src/app/redux/actions/isLoggedIn';


const initialState = {
  logged: null
};

const authorizeReducer = (state = initialState, action) => ({
  [IS_LOGGED_IN_TRUE]: () => ({ ...state, logged: true }),
  [IS_LOGGED_IN_FALSE]: () => ({ ...state, logged: false })
}[action.type] || (() => state))();

export default authorizeReducer;
